const TRANSLATION = {
  buyModal: {
    afterFree: 'Po vašej bezplatnej skúške',
    btn: 'Skúste to zadarmo',
    freeTrial: '3-dňový bezplatný zkušebný období',
    monthLabel: 'mesiac',
    selectLabel: 'Vyberte plán',
    title: 'Predplatné',
    yearLabel: 'rok',
  },
  contact: {
    block1:
      'Pre prispôsobenie, otázky alebo návrhy nás kontaktujte na adrese contact@noam.tools. Odpovieme vám rýchlo.',
    block2: 'Podporte nás hodnotením v obchode rozšírení Google Apps s hodnotením ★★★★★.',
    block3: 'Pomôžte ostatným zdieľaním tejto prípony:',
    title: 'Kontaktujte nás',
  },
  help: {
    AquickOverviewOfNoam: 'Rýchly prehľad o Noame',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Správa obľúbených',
    Fixedplugin: 'Opravený plugin',
    Focusing: 'Zameranie',
    Free: 'Zadarmo',
    FreeTrialBenefits: 'Výhody bezplatnej skúšobnej verzie',
    GoWithWikipedia: 'Použite Wikipédiu',
    GoWithYouTube: 'Idite s YouTube',
    HoverTranslation: 'Preklad pri najazdení myšou',
    Howtouse: 'Ako používať',
    ImageTranslation: 'Preklad obrázku',
    InstantTranslation: 'Okamžitý preklad',
    Membership: 'Členstvo',
    NoamHelp: 'Noam vám pomáha prekladať a sumarizovať',
    PDFparallelTranslation: 'Paralelný preklad PDF',
    ParallelTranslation: 'Paralelný preklad',
    SkipAllSteps: 'Preskočiť všetky kroky',
    Summary: 'Zhrnutie',
    Translation: 'Preklad',
    TryItForFree: 'Skúste to zadarmo',
    Video: 'Video',
    VideoSummary: 'Zhrnutie videa',
    VideoTranslation: 'Preklad videa',
    WebSummary: 'Zhrnutie webu',
    WordSelectionTranslation: 'Preklad výberu slov',
    benefits: 'Máme pre Vás čakajúce výhody!',
    dayFree: '3-dňový bezplatný zkušební période',
    done: 'Hotovo',
    next: 'Ďalšie',
    pin: 'Pripnite Noama pre ľahší prístup～～',
    planIsNotExist: 'Plán nie je dostupný',
    startWiki: 'Začnime s Wiktionáriom!',
    startYoutube: 'Začnime s YouTube!',
    try: 'Vyskúšajte to',
    tryNow: 'Skúste to teraz!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dvojjazyčná preklad + Chat PDF',
      sub1: {
        desc: 'Dvojjazyčné čítanie vám umožňuje porovnávať originálny text a preklad vedľa seba, čím zvyšuje účinnosť čítania.',
        title: 'Dvojjazyčné čítanie',
      },
      sub2: {
        desc: 'AI analyzuje a sumarizuje a môže odpovedať na vaše otázky na základe obsahu PDF.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'Preklad PDF s podporou umelej inteligencie pre vyššiu presnosť a efektívnosť.',
        title: 'Presnosť a účinnosť',
      },
      title: 'Preklad PDF',
    },
    aiAssistant: {
      desc: 'Zefektívnenie a zjednoduchšenie webového prekladu',
      panel1: {
        desc: 'Dvojjazyčné preklady s prepojeniami vám pomôžu porovnať originálny text s prekladom, takže budete lepšie rozumieť a zvýšite efektivitu čítania.',
        title: 'Dvojjazyčný preklad',
      },
      panel2: {
        left: {
          desc: 'Pri prehliadaní webovej stránky najednite myšou na obsah, ktorý chcete preložiť, aby ste videli preklad.',
          title: 'Preklad pri najazdení',
        },
        right: {
          desc: 'Pri prehliadaní webovej stránky vyberte text, ktorý chcete preložiť, aby ste videli preklad.',
          title: 'Preklad výberu textu',
        },
      },
      panel3: {
        one: {
          desc: 'Prekladajte a sumarizujte webové stránky a videoobsah kedykoľvek, kdekoľvek, za hladký zážitok!',
          title: 'Kliknutím a ukazovateľom',
        },
        three: {
          desc: 'Veľký jazykový model riadený umelou inteligencou zaisťuje presnosť a konzistenciu prekladu pre zlepšené čitateľské zážitky.',
          title: 'AI-ovládaný',
        },
        two: {
          desc: 'Všeobecné pokrytie viacerých jazykov, dvojjazykové bezbariérové čítanie, preklad jedným kliknutím – zažite rozdiel!',
          title: 'Viac komplexné a pohodlné',
        },
      },
      panel4: {
        tab1: {
          desc: 'Váš expert na efektívnosť – pomocou ChatGPT prekladá a sumarizuje obsah YouTube videí, aby vám ušetril čas!',
          key: 'Video',
          title: 'Preklad a súhrn videa',
        },
        tab2: {
          desc: 'Kliknite pre preklad obrázkov pri prehliadaní webu.',
          key: 'Obrázok',
          title: 'Preklad obrázku',
        },
        tab3: {
          desc: 'Okamžite extrahuje kľúčové informácie z webových stránok a poskytuje zhrnutie, čím zvyšuje vašu čitateľnú efektivitu.',
          key: 'Web',
          title: 'Preklad a zhrnutie webu',
        },
        tag1: 'Jednoduchý',
        tag2: 'Efektívny',
        tag3: 'Jednoducho pochopiteľné',
      },
      title: 'AI Asistent',
    },
    getStart: 'Začať',
    getStartedForFree: 'Začnite zadarmo',
    howItWork: {
      desc: 'Noam integruje AI modely, aby poskytoval používateľom inteligentný zážitok z prekladu a zhrnutia webových stránok medzi jazyky, prekladu PDF a obrázkov, prekladu a zhrnutia videí',
      title: 'Ako to funguje',
    },
    lastBlock: { desc: 'Lepšia AI preklad pre plynulejší čitateľský zážitok' },
    top: {
      desc: 'Noam je bezplatná AI rozšírenie pre prehliadač, ktoré vám pomáha prekladať a zhrňovať webové stránky, videá a obsah PDF.\n      Prihláste sa k Noamovi a zažite túto magiu!',
      title1: 'Jedna Magia',
      title2: 'Jeden klik',
    },
    userReviews: {
      desc: 'Hodnotenia s päť hviezdami v Chrome Web Store',
      title: 'Recenzie používateľov',
    },
  },
  installTips: {
    btn: 'Skúste to teraz',
    text: 'Nainštalujte si "Noam Browser Plugin", aby ste odblokovali viac funkcii! Medzi nimi patrí prepájanie webových stránok,\n    sumarizácia webových videí a ďalšie!',
  },
  locale: {
    af: 'afrikáansky',
    am: 'amharština',
    ar: 'arabčina',
    as: 'asamština',
    auto: 'Automatické rozpoznanie',
    az: 'azerbajdžanský',
    ba: 'baškir',
    bg: 'bulharský',
    bn: 'bangla',
    bo: 'tibetanský',
    bs: 'bosniacina',
    ca: 'katalánsky',
    cs: 'čeština',
    cy: 'walecký',
    da: 'dánsky',
    de: 'nemecký',
    dsb: 'Dolní srbština',
    dv: 'divehi',
    el: 'grécky',
    en: 'Angličtina',
    es: 'španielčina',
    et: 'eesti',
    eu: 'baskičtina',
    fa: 'perzský',
    fi: 'finská',
    fil: 'filipínsky',
    fj: 'fidžijský',
    fr: 'francúzsky',
    frCA: 'francúzsky (Kanada)',
    ga: 'Ír',
    gl: 'galicijský',
    gom: 'konkánčina',
    gu: 'gujarátčina',
    ha: 'hausa',
    he: 'hebrejština',
    hi: 'hindčina',
    hr: 'hrvatsky',
    hsb: 'hornjosorbština',
    ht: 'haiťanský kreól',
    hu: 'maďarčina',
    hy: 'arménsky',
    id: 'indonézsky',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'islandský',
    it: 'talianska',
    iu: 'inuktitut',
    iuLatn: 'inuktitut (latinčina)',
    ja: 'japonský',
    ka: 'gruzínsky',
    kk: 'Kazachština',
    km: 'khmérsky',
    kmr: 'kurdština (severná)',
    kn: 'kannadština',
    ko: 'kórejsky',
    ku: 'kurdsky (stredný)',
    ky: 'kyrgyzský',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'litovský',
    lug: 'Ganda',
    lv: 'latvijský',
    lzh: 'čínština (literárna)',
    mai: 'Maithili',
    mg: 'malagášsky',
    mi: 'Māori',
    mk: 'makedónsky',
    ml: 'malajálam',
    mnCyrl: 'mongolčina (cyrilica)',
    mnMong: 'mongolčina (tradičná)',
    mr: 'maráthijský',
    ms: 'malajzijský',
    mt: 'maltecký',
    mww: 'Hmong Daw',
    my: 'Mjanmarsko (barmersky)',
    nb: 'nórsky',
    ne: 'nepálsky',
    nl: 'nizozemský',
    noSearchLang: 'Jazyk nie je podporovaný',
    nso: 'Severné sesotho',
    nya: 'Nyanja',
    or: 'odijská',
    otq: 'Querétaro Otomi',
    pa: 'pendžábčina',
    pl: 'polský',
    placeholder: 'Hľadať',
    prs: 'Dari',
    ps: 'paštunčina',
    pt: 'portugalčina (Brazília)',
    ptPT: 'portugalština (Portugalsko)',
    ro: 'romunsky',
    ru: 'ruský',
    run: 'Rundi',
    rw: 'kinyarwanda',
    sd: 'sindhijčina',
    si: 'sinhálčina',
    sk: 'slovenský',
    sl: 'slovinský',
    sm: 'samoánsky',
    sn: 'shona',
    so: 'Somálsky',
    sq: 'albánsky',
    srCyrl: 'srbština (cirilica)',
    srLatn: 'srbština (latinčina)',
    st: 'sesotho',
    sv: 'švédsky',
    sw: 'svahili',
    ta: 'tamilčina',
    te: 'telugu',
    th: 'thajský',
    ti: 'tigrinjština',
    tk: 'turkmenský',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingončina (pIqaD)',
    tn: 'setswana',
    to: 'tonga',
    tr: 'turecký',
    tt: 'tatár',
    ty: 'tahitanský',
    ug: 'Ujgur',
    uk: 'ukrajinský',
    ur: 'urdština',
    uz: 'uzbek (latinčina)',
    vi: 'vietnamčina',
    xh: 'Xhosa',
    yo: 'jorubština',
    yua: 'jukatecký maya',
    yue: 'kantončina (tradičná)',
    zh: 'čínsky',
    zhHans: 'Zjednodušený čínština',
    zhHant: 'Tradicionálny čínsky',
    zu: 'Zulu',
  },
  login: {
    and: 'a',
    btn: 'Prihlásiť sa cez Google',
    btn1: 'Prihlásiť sa teraz',
    desc: 'Prihláste sa, aby ste odomknuli viac skúseností',
    policy: 'Zásady ochrany súkromia',
    terms: 'Podmienky používania',
    tips: 'Pri registrácii súhlasím s',
    title: 'Vitajte v Noame',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Sledovať', twitter: 'Twitter' },
    legal: { policy: 'Zásady ochrany osobných údajov', terms: 'Podmienky služby', title: 'Právo' },
    product: {
      image: 'Preklad obrázka',
      pdf: 'Preklad PDF',
      title: 'Produkty',
      video: 'Preklad a súhrn videa',
      web: 'Preklad a zhrnutie webu',
    },
    resources: { title: 'Zdroje' },
    tools: { title: 'Nástroje', pdf: 'Preklad PDF' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Pomoc',
    logout: 'Odhlásiť sa',
    logoutSucc: 'Odhlásený.',
    pricing: 'Ceny',
    settings: 'Nastavenia',
    signUp: 'Prihlásiť sa',
  },
  pdf: {
    autoDetect: 'Automatické rozpoznanie',
    cancelBtn: 'Zrušiť',
    cancelUpload: 'Zrušiť',
    chatPdf: {
      summaryError: 'Zhrnutie zlyhalo, skúste to prosím neskôr znova',
      chatError: 'Chat zlyhal, skúste to prosím neskôr znova',
      Search: 'Hľadať',
      cancel: 'Zrušiť',
      chatTitle: 'Vitajte v Noame! Tu je súhrn vášho PDF: ',
      clear: 'Jasný',
      clearContent: 'Spustí sa nová konverzácia. Aktuálna konverzácia sa neuloží. Ste si istý/á?',
      clearDialogTitle: 'Prosím potvrďte',
      clearSucc: 'Vyčištěno',
      copy: 'Kopírovať',
      copySucc: 'Skopírované',
      delete: 'Vymazať',
      deleteCancel: 'Zrušiť',
      deleteContent: 'Tento PDF sa po vymazaní nemôže obnoviť. Ste si istý/á?',
      deleteOk: 'Vymazať',
      deleteSuccess: 'Vymazané',
      deleteTitle: 'Potvrdiť vymazanie',
      expand: 'Zrútenie',
      historyTitle: 'Dejiny',
      listError:
        'Nepodarilo sa načítať čitateľskú zoznam. Skúste to prosím neskôr znova alebo kontaktujte podporu.',
      loading: 'Načítava sa...',
      noDataDesc: 'Zatiaľ žiadna história.',
      noMore: 'Žiadnej ďalšej obsahu.',
      placeholder: 'Otázajte sa čohokoľvek o tomto PDF',
      summaryTitle: 'Možno budete zaujímaví tieto otázky:',
    },
    collectionEmpty: 'Vaša kolekcia je prázdna.',
    collectionTab: 'Poznámky',
    dataLoading: 'Načítava sa...',
    dialogContent: 'Ste si istý/á, že to chcete vymazať?',
    dialogTitle: 'Prosím potvrďte',
    download: {
      both: 'dvojjazyčný',
      btn: 'Uložiť',
      cancel: 'Zatvorenie tohto okna zruší stiahnutie PDF. Ste si istí, že chcete zrušiť?',
      desc: 'Uložiť do zariadenia: Sťahuje preklady ako obrázky; Uložiť a tlačiť: Sťahuje preklady v pôvodnom formáte s podporou kopírovania.',
      download: 'Stiahnuť',
      downloadMsg1: 'Pokrok prekladu PDF:',
      downloadMsg2: 'Odhadovaný zostávajúci čas:',
      downloadSucc: 'PDF je pripravený! Kliknite pre uloženie.',
      downloadTip: 'Sťahovanie PDF. Aby ste predišli chybe pri sťahovaní, nezavírajte toto okno.',
      error: 'Uloženie zlyhalo. Skúste namiesto toho vytlačiť.',
      fileName: 'Názov súboru:',
      fileType: 'Typ súboru:',
      loading: 'Ukladanie...',
      loading2: 'Načítava sa...',
      minute: 'Minúty...',
      msg1: 'Niektoré preklady v tomto dokumente sú dlhšie ako pôvodný text a môžu sa prekrývať v stiahnutom súbore. Odporúčame čítať na webe.',
      msg2: 'Preklad ešte nie je dokončený. Stiahnite si ho po dokončení prekladu.',
      msg3: '2. Niektoré preklady sú príliš dlhé. Prečítajte si ich na webe, aby ste sa vyhli prekrývaniu textu.',
      msg4: 'Preklady sú v priebehu. Skúste to znova po ich dokončení.',
      progress:
        'Preklad PDF. Pokrok: {{progress}}, Odhadovaný zostávajúci čas: {{minutes}} minút...',
      save: 'Uložiť do zariadenia',
      savePrint: 'Uložiť a tlačiť',
      success: 'Stiahnuté',
      trans: 'Len preklad',
      transContinue: 'Pokračujte v preklade',
    },
    downloadBtn: 'Stiahnuť',
    dragTipModal: {
      black: ' priestor',
      leftKey: 'ľavé tlačidlo',
      ok: 'Pochopil som',
      press: 'Stlačte',
      tips: 'tlačiť a zobraziť',
    },
    entry: 'PDF súbory',
    fileErrMsg: 'Čítanie súboru zlyhalo. Skúste to prosím neskôr alebo sa obráťte na podporu.',
    fileMsg: 'Aktuálna veľkosť súboru:',
    fileMsg2: 'Prosím nahrajte súbor menší ako 300MB.',
    freeBannerBtn: 'Upgrade',
    freeBannerTips: 'Dosažený limit bezplatných prekladov PDF',
    guide: {
      placeholder: 'Vložte odkaz na PDF sem',
      start: 'Začať preklad',
      text1: 'Dvojjazyčné čítanie',
      text2:
        'Čítajte dvojjazyčne, aby ste mohli porovnávať originálny text a preklad vedľa seba, čím zvýšite svoju efektivitu.',
      text3: 'Rozhovor s vašim PDF',
      text4:
        'Analýza a sumarizácia s podporou umelej inteligencie. Kládejte otázky ohľadom vášho PDF a získajte okamžité odpovede.',
      text5: 'Presný a efektívny',
      text6: 'Preklad PDF s podporou umelej inteligencie pre vyššiu presnosť a efektivitu.',
      title1: 'Dvojjazyčné prekladanie',
      title2: 'Chatujte s vaším PDF',
      toast: 'Prosím, zadajte platný online odkaz na PDF súbor končiaci .pdf',
    },
    hasTransTask: 'Prebieha úloha prekladu. Prosím, počkajte.',
    hoverTrans: 'Odstavce s prekladom pri prechode myšou',
    initial: 'Preložiť PDF',
    installText: 'Váš všestranný riešenie pre každodenné preklady.',
    installText2: 'Najprv nainštalujte rozšírenie',
    installTips:
      'Inštalujte rozšírenie pre ešte viac prekladov PDF a plynulejšie preklady webových stránok:',
    kw: 'hrebík',
    link: 'odkaz',
    listError:
      'Nepodarilo sa načítať PDF súbory. Skúste to prosím neskôr znova alebo sa obraťte na podporu.',
    memoTotalCount: 'Celkom 1 položka',
    new: 'nový súbor',
    noId: 'ID súboru nenájdené.',
    notPdf: 'Iba súbory PDF.',
    okBtn: 'Vymazať',
    okBtn2: 'Pochopil som',
    original:
      'Ste veľmi presná a spoľahlivá AI navrhnutá na generovanie výstupu JSON, ktorý presne zodpovedá špecifikovanému JSON schéme.\n\nMusíte nasledovať tieto pravidlá:\n1. Štandardne dodržiavať štruktúru JSON schémy.\n2. Presne zhodovať všetky dátové typy, požadované polia a obmedzenia.\n3. NEVKLÁDAJTE žiadny extra text, vysvetlenie, markdown ani komentáre.\n4. VYPUSTITE IBA objekt JSON — bez blokov kódu, bez preambuły, bez obalenia.\n\nInformácie o schéme sú uvedené nižšie.\n- Názov schémy: translate_result\n- JSON schéma:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Rovnoběžný',
    parseErrDialogContent:
      'Tento odkaz na PDF nie je možné preložiť priamo. Stiahnite si PDF a nahrajte ho pre preklad.',
    parseErrTips: 'Nepodarilo sa analyzovať súbor',
    parseFileToast: 'Zlyhalo parsovanie súboru. Skúste to prosím neskôr alebo kontaktujte podporu.',
    pdfLoading: 'Analýza...',
    searchPlaceholder: 'Hľadať',
    selectTrans: 'Vyberte text na preklad',
    shareBtn: 'Zdieľať',
    shareBtnText1: 'Vytvoriť odkaz na zdieľanie',
    shareBtnText2: 'Aktualizovať zdieľaný obsah',
    shareModal: {
      cancel: 'Zrušiť',
      copy: 'Kópia',
      copySucc: 'Odkaz skopírovaný',
      custom: 'Prispôsobit:',
      errMsg: 'Vybrané obsah ešte nie je úplne preložený. Pred zdieľaním ho prosím preložte.',
      gen: 'Zdieľať',
      modify: 'Upraviť',
      notSupport: 'Tento jazyk nie je momentálne podporovaný.',
      page: 'Stránky',
      pageNuErr: 'Prosím, zadajte platné číslo strany.',
      range: 'Rozsah:',
      remain: 'zostávajúci',
      remain1: 'Celkový odhadovaný čas:',
      search: 'Hľadať',
      settings: 'Nastavenia zdieľania:',
      shareSetting: 'Nastavenia zdieľania',
      shareText: 'Zdieľať',
      shareTips: 'Zdieľajte odkaz na preložené PDF so svojimi priateľmi:',
      sourceLang: 'Od:',
      target: 'Komu:',
      text1: 'Nastavenia zdieľania',
      text2: 'Vytvoriť zdieľaný odkaz',
      totalPage: 'celkom 1 strana',
      trans: 'Preložiť',
      translateTips: 'Tip: Ak preklad trvá dlhšie, môžete zatvoriť toto okno a zdieľať neskôr.',
      translating: 'Prekladanie PDF...',
      update: 'Aktualizovať zdieľaný odkaz',
    },
    shareMsg1: 'Vytvorený odkaz na zdieľanie.',
    shareMsg2: 'Zdieľaný obsah bol aktualizovaný.',
    shareMsg3:
      'Nepodarilo sa vygenerovať zdieľaný odkaz. Skúste to neskôr znova alebo kontaktujte podporu.',
    shareMsg4:
      'Nepodarilo sa aktualizovať zdieľaný obsah. Skúste to prosím neskôr znova alebo kontaktujte podporu.',
    shareTips: 'Váš preklad PDF je pripravený! Zdieľajte ho so svojimi priateľmi.',
    start: 'Začnite bezplatnú skúšku',
    thumbnail: 'Obsah',
    toast1: 'Načítava sa PDF. Skúste to prosím neskôr znova.',
    toast2: 'Obsah PDF sa spracúva. Dialóg momentálne nie je podporovaný.',
    toast3: 'Prebieha sťahovanie. Skúste to znova po dokončení sťahovania.',
    toolbar: { Adjust: 'Upraviť', autoFit: 'Automatické prispôsobenie' },
    trans: 'Preklad',
    transSucc: 'Preklad úspešný!',
    unLoginToast: 'Prosím, prihláste sa na používanie tejto funkcie.',
    uploadBtn: 'Nahrať',
    uploadErr:
      'Nahrávanie súboru zlyhalo. Skúste to prosím neskôr znova alebo sa obraťte na podporu.',
    uploadErrSignUrl:
      'Nepodarilo sa získať URL pre nahratie. Skúste to prosím neskôr alebo kontaktujte podporu.',
    uploadMsg1: 'Sem presuňte a uvoľnite váš súbor.',
    uploadMsg2: 'Podporované typy súborov: PDF  |  Maximálna veľkosť súboru: 300MB',
    uploadMsg3: 'Kliknite na výber súborov alebo ich presuňte sem a pušte.',
    uploading: 'Nahrávanie',
    uploadingMsg: 'Nahrávam. Prosím počkajte.',
    uploadingMsg1: 'Súbor sa nahráva. Skúste to prosím neskôr znova.',
    uploadingMsg2: 'Súbor sa práve konvertuje. Skúste to prosím neskôr znova.',
    uploadingMsg3:
      'Žiadosť o priebeh konverzie zlyhala. Skúste to prosím neskôr alebo kontaktujte podporu.',
    uploadingMsg4:
      'Noam nemôže pristupovať k lokálnym súborom. Prosím, manuálne nahrajte PDF pre preklad.',
    uploadingMsg5:
      'Nepodarilo sa získať URL súboru. Skúste to prosím neskôr alebo sa obraťte na podporu.',
    video: 'video',
    vipBannerBtn: 'Upgrade',
    vipBannerTips: 'Dosegli ste limit prekladov PDF súborov na tento mesiac.',
    webTrans: 'Úplné preukazovanie',
  },
  pricing: {
    FAQ: 'Často kladené otázky',
    FQAObj: {
      a1: 'Áno, Noam ponúka bezplatný plán, ktorý môžete použiť hneď.',
      a2: 'Ponúkame tri členské plány: Pro, Pro+ a Enterprise. Môžete si vybrať mesačný alebo ročný platobný termín. Ročné fakturácia prináša značné úspory.',
      a3: 'Všetky funkcie sú dostupné v oboch planoch. Hlavný rozdiel je cena: ročné predplatné celkovo stoji menej. Mesačné predplatné sa fakturuje každý mesiac, zatiaľ čo ročné plány sa fakturujú raz za rok.',
      a4: 'Předplatné môžete zrušiť kedykoľvek v nastaveniach účtu.',
      q1: 'Existuje bezplatný plán?',
      q2: 'Aké cenové plány a možnosti platby sú dostupné?',
      q3: 'Aký je rozdiel medzi mesačnou a ročnou predplatnosťou?',
      q4: 'Ako zruším moje predplatné?',
    },
    around: 'Około',
    billedMonthly: 'Fakturácia mesačne',
    billedYearly: 'Fakturované ročne',
    day: 'deň',
    desc: 'Porovnajte plány a vyberte najlepší',
    detailedCompare: 'Porovnaj plány',
    discount: '20% zľava',
    enterprise: {
      benefit1: 'Prioritná zákaznická podpora',
      benefit2: 'Viac užívateľov',
      benefit3: 'Prispôsobené riešenia',
      benefit5: 'Vymenovaný manažér účtu',
      btn: 'Kontaktujte nás',
      recommendText: 'Vlastné plány (≥3 osoby)',
      talkToUs: 'Kontaktujte nás',
    },
    free: {
      benefit1: 'Okamžitý preklad 100 krát denne',
      benefit2: 'Preklad webstránky a zhrnutie',
      benefit3: '30 prekladov obrázkov',
      benefit4: 'Preklad a súhrn videa',
      benefit5: '10 prekladov PDF',
      benefit6: '5 000 tokenov',
      btn: 'Vyskúšajte zadarmo',
      recommendText: 'Zadarmo skúšobná verzia',
    },
    imageTranslation: 'Preklad obrázku',
    month: 'mesiac',
    monthly: 'Mesačný',
    pageTitle: 'Cenník',
    pdf: { chat: 'PDF Chat Dotazy', maxPage: 'Max. stránok na PDF', translation: 'Preklad PDF' },
    preMonth: 'Za mesiac',
    pro: {
      benefit1: 'Prioritná zákaznícka podpora',
      benefit2: '1 000 000 tokenov/mesiac',
      benefit3: 'Preklad webových stránok a zhrnutie',
      benefit4: '200 prekladov obrázkov',
      benefit5: 'Preklad a zhrnutie videa',
      benefit6: '200 prekladov PDF',
      btn: 'Začať',
      recommendText: 'Najpopulárnejšie',
    },
    proPlus: {
      benefit1: 'Prioritná zákaznická podpora',
      benefit2: '3 000 000 tokenov/mesiac',
      benefit3: 'Preklad webových stránok a súhrn',
      benefit4: '500 prevodov obrázkov',
      benefit5: 'Preklad a zhrnutie videa',
      benefit6: '500 prekladov PDF',
      recommendText: 'Najlepšia hodnota',
    },
    video: { summary: 'Zhrnutie videa', translation: 'Preklad videa' },
    web: {
      contrastiveTranslation: 'Dvojjazyčné prekladanie',
      dictionaryTranslation: 'Výber prekladu',
      hoverTranslation: 'Preklad pri najazdení myšou',
      instantTranslation: 'Okamžitá preklad',
      summary: 'Zhrnutie webovej stránky',
    },
    yearly: 'ročne',
  },
  privacy: {
    block1:
      'Noam ("Noam", "my", "náš" alebo "nás") respektuje vašu súkromie a je záväzné chrániť všetky informácie, ktoré získame od vás alebo o vás. Táto zásada ochrany súkromia popisuje naše postupy týkajúce sa zhromažďovania alebo používania osobných údajov pri používaní našich webových stránok, aplikácií a služieb (spoločne označovaných ako „Služby“). Táto zásada ochrany súkromia sa nevzťahuje na obsah, ktorý spracovávame v prospech našich firemných zákazníkov, ako napríklad náš API. Použitie týchto údajov podlieha našej zmluve s zákazníkmi, ktorá sa týka prístupu k týmto produktom a ich používania.',
    block10:
      'Implementujeme komerčne rozumné technické, administratívne a organizačné opatrenia na ochranu online a offline osobných údajov pred strátou, zneužitím, neoprávneným prístupom, zverejnením, zmenou alebo závažnými činmi. Avšak žiadna internetová alebo e-mailová prenos nemôže garantovať úplnú bezpečnosť alebo presnosť. Obzvlášť e-maily poslané nám alebo od nás nemusia byť bezpečné. Preto by ste mali byť obzvlášť opatrní pri rozhodovaní, aké informácie nám pošlete prostredníctvom služby alebo e-mailu. Okrem toho nie sme zodpovední za akékoľvek narušenie nastavení súkromia alebo bezpečnostných opatrení v službe alebo v nastaveniach súkromia alebo bezpečnostných opatrení webových stránok tretích strán. Uchovávame vaše osobné údaje tak dlho, ako je to potrebné na poskytnutie služieb alebo na iné legitímne obchodné účely, ako je riešenie sporov, bezpečnosť a bezpečnosť, alebo dodržovanie právnych povinností. Dĺžka doby uchovávania osobných údajov závisí od mnohých faktorov, ako je množstvo, povaha, citlivosť informácií, potenciálne rizika neoprávneného použitia alebo zverejnenia, účely, pre ktoré spracúvame informácie, a ďalšie právne záväzné úvahy.',
    block11:
      'Túto Zásady ochrany osobných údajov môžeme občas aktualizovať. Keď to urobíme, uverejníme aktualizovanú verziu na tejto stránke, pokiaľ to nevyžaduje príslušné právne predpisy inak.',
    block12:
      'Ak máte akékoľvek nevyriešené otázky alebo obavy ohľadom tejto zásady ochrany osobných údajov, kontaktujte prosím náš zákaznícky servis. Email:',
    block2: 'Zbierame nasledujúce osobné údaje ("Osobné údaje") týkajúce sa vás:',
    block3:
      'Informácie, ktoré ste nám poskytli: Keď vytvoríte účet na použitie našich služieb alebo sa s nami komunikujete, zbierame osobné údaje nasledovne:',
    block4:
      'Osobné údaje automaticky získané z vašej používania služieb: Keď pristupujete k službám, ich používate alebo s nimi interagujete, získavame nasledujúce informácie o vašom prístupe, používani alebo interakcii ("Technické informácie"):',
    block5: 'Osobné údaje môžeme používať na nasledujúce účely:',
    block6:
      'Zhrnutie alebo odidentifikovaná informácia: Môžeme zhromažďovať alebo odidentifikovať osobné údaje, aby sme zabránili ich opätovnému použitiu na účely identifikácie, a používať takéto informácie na analýzu účinnosti našich služieb, zlepšenie a pridanie funkcií našich služieb, výskum a podobné účely. Navyše môžeme analyzovať všeobecné správanie a vlastnosti používateľov našich služieb a zdieľať zhromaždené informácie s tretími stranami, publikovať takéto zhromaždené informácie alebo urobiť ich všeobecne dostupné. Zhromažďované informácie môžeme zbierať prostredníctvom služieb, prostredníctvom cookies a prostredníctvom iných spôsobov popísaných v tejto zásade ochrany osobných údajov. Odidentifikované informácie budeme udržiavať a používať v anonymnej alebo odidentifikovanej forme, a nebudeme sa snažiť takéto informácie znova identifikovať, pokiaľ to nevyžaduje zákon.',
    block7:
      'V určitých prípadoch môžeme vaše osobné údaje poskytnúť tretím stranám bez ďalšieho upozornenia vás, pokiaľ to zákon nevyžaduje:',
    block8:
      'V závislosti od vašej geografickej polohy môžu jednotlivci v Európskom hospodárskom priestore, Spojenom kráľovstve a celosvetovo mať určité zákonné práva týkajúce sa ich osobných údajov. Napríklad môžete mať právo na:',
    block9:
      'Služba môže obsahovať odkazy na ďalšie webové stránky, ktoré nepoužíva ani nekontroluje spoločnosť Noam, vrátane služieb sociálnych médií („stránky tretích strán“). Informácie, ktoré zdieľate so stránkami tretích strán, budú riadené konkrétnymi zásadami ochrany osobných údajov a podmienkami služby týchto stránok tretích strán, nie touto zásadou ochrany osobných údajov. Poskytujeme tieto odkazy pre pohodlie a nepredpokladáme ich záruku ani recenziu. Pre informácie o ich zásadách ochrany osobných údajov a podmienkach sa prosím priamo obráťte na stránky tretích strán.',
    subBlock1:
      'Informácie o účte: Pri vytváraní účtu na našej platforme zbierame informácie súvisiace s vaším účtom, vrátane vášho mena, kontaktných údajov, povereník na prístup k účtu, informácií o platobnej karte a histórie transakcií („Informácie o účte“).',
    subBlock10: 'Poskytovanie, správanie, údržba a/alebo analýza služieb;',
    subBlock11: 'Komunikácia s vami',
    subBlock12: 'Vývoj nových produktov a služieb;',
    subBlock13:
      'Prevencia podvodu, kriminálnej činnosti alebo zneužitia našich služieb a ochrana bezpečnosti našich IT systémov, architektúry a sietí;',
    subBlock14: 'Prevádzanie prevodov podnikov;',
    subBlock15:
      'Dodržiavanie právnych povinností a právnych konaní, ochrana našich práv, súkromia, bezpečnosti alebo vlastníctva, ako aj týchto našich spoločníkov, vás alebo iných tretích strán.',
    subBlock16:
      'Dodávatelia a poskytovatelia služieb: Na pomoc pri splnení obchodných operačných potrieb a vykonávaní určitých služieb a funkcií môžeme poskytnúť osobné údaje dodávateľom a poskytovateľom služieb, vrátane poskytovateľov hostingových služieb, poskytovateľov cloudových služieb a ďalších poskytovateľov informačných technologických služieb, softvéru pre e-mailovú komunikáciu a poskytovateľov služieb webového analytického monitorovania atď. Títo partneri budú mať prístup k osobným údajom, ich spracovávať alebo ukladať iba na našej inštrukcii pri vykonávaní svojich povinností na našu úkor.',
    subBlock17:
      'Prenosy podnikov: Ak sa zapojíme do stratégických transakcií, reorganizácií, bankrotov, prevziatí bankrotu alebo prechodu služieb na iného poskytovateľa (spoločne označovaných ako „Transakcie“), vaše osobné údaje a ďalšie informácie môžu byť počas dôkladnej skúmania zdieľané s transakčnými protistranami a ďalšími stranami pomáhajúcimi pri Transakciách a prenesené ako súčasť Transakcií spolu s inými aktívami na nástupnú spoločnosť alebo spoločníkovú spoločnosť.',
    subBlock18:
      'Právozanedbateľné požiadavky: Môžeme zdieľať vaše osobné údaje s vládnymi úradmi, priateľmi z odvetvia alebo inými tretími stranami, vrátane informácií o vašej interakcii s našimi službami, (1) ak to vyžaduje zákon alebo ak si myslíme, že táto akcia je potrebná na splnenie právnych povinností; (2) na ochranu a obhajobu našich práv alebo vlastníctva; (3) ak jednosmerne určíme, že došlo k porušeniu našich podmienok, politík alebo zákonov; (4) na zistenie alebo prevenciu podvodu alebo iných nezákonných činností; (5) na ochranu našich produktov, zamestnancov alebo používateľov, alebo verejného bezpečnosti, bezpečnosti, integritácie; alebo (vi) na obhajobu proti právnej zodpovednosti.',
    subBlock19: 'Prístup k vašim osobným údajom a informáciám o tom, ako sa spracúvajú.',
    subBlock2:
      'Keď používate naše služby, zbierame osobné údaje z vašich vstupov, nahratých súborov alebo spätnej väzby, ktorú nám poskytnete („Obsah“).',
    subBlock20: 'Požiadajte o odstránenie vašich osobných údajov z našich záznamov.',
    subBlock21: 'Skontrolujte alebo aktualizujte svoje osobné údaje.',
    subBlock22: 'Premiestnenie vašich osobných údajov tretiej strane (prenosnosť údajov).',
    subBlock23: 'Obmedzte spracovanie vašich osobných údajov.',
    subBlock24:
      'Umiestnite vaše súhlas — tam, kde spolieham na súhlas ako právnu základ pre spracovanie, môžete svoj súhlas kedykoľvek odvolať.',
    subBlock25: 'Vystaviť sa nám s nesúhlasom s spracovaním vašich osobných údajov.',
    subBlock26: 'Zlepšovanie našich služieb a vykonávanie výskumu;',
    subBlock3:
      'Komunikačná informácia: Ak nám posielate správy, budeme zbierať vaše meno, kontaktné údaje a obsah vašich správ („Komunikačná informácia“).',
    subBlock4:
      'Informácie o sociálnych médiách: Máme stránky na webových stránkach sociálnych médií, ako sú Instagram, Facebook, Medium, Twitter, YouTube a LinkedIn. Keď interagujete s našimi stránkami sociálnych médií, zbierame osobné údaje, ktoré nám si zvolíte poskytnúť, ako sú vaše kontaktné údaje („Sociálne informácie“). Okrem toho spoločnosti, ktoré hostujú naše stránky sociálnych médií, nám môžu poskytnúť zhlukované informácie a analýzy o našich aktivitách v sociálnych médiách.',
    subBlock5:
      'Logové údaje: Informácie automaticky poslané vášim prehliadačom pri používaní našich služieb. Logové údaje zahŕňajú vašu internetovú protokolovú (IP) adresu, typ a nastavenia prehliadača, dátum a čas vašich požiadaviek a spôsob interakcie s našou webstránkou.',
    subBlock6:
      'Používateľské údaje: Môžeme automaticky zhromažďovať informácie o vašom používaní služby, ako sú typy obsahu, ktorý prezeráte alebo s ktorým interagujete, funkcie, ktoré používate, akcie, ktoré vykonávate, ako aj vaša časová zóna, krajina, dátum a čas prístupu, používateľský agent a verzia, typ počítača alebo mobilného zariadenia a vaše pripojenie počítača.',
    subBlock7:
      'Informácie o zariadení: Obsahuje názov zariadenia, operačný systém, identifikátor zariadenia a prehliadač, ktorý používate. Zozbierané informácie môžu závisieť od typu zariadenia, ktoré používate, a jeho nastavení.',
    subBlock8:
      'Cookies: Používame cookies na fungovanie a správu našich služieb, ako aj na zlepšenie vášho zážitku. "Cookie" je informácia, ktorú webová stránka, ktorú navštívite, odosiela do vášho prehliadača. Môžete nastaviť prehliadač tak, aby prijímal všetky cookies, odmietal všetky cookies alebo vás upozorňoval, keď sa poskytuje cookie, aby ste mohli pri každom prístupe rozhodnúť, či ho prijmete. Odmietnutie cookies však môže zabrániť vám používaniu alebo negatívne ovplyvniť zobrazenie alebo funkčnosť určitých oblastí alebo funkcií webu. Pre viac informácií o cookies navštívte All About Cookies.',
    subBlock9:
      'Analytika: Môžeme používať rôzne online analytické produkty, ktoré používajú cookies, aby nám pomohli analyzovať, ako používatelia používajú naše služby, a zlepšiť vaše skúsenosti pri používaní služieb.',
    subTitle1: 'Osobné údaje, ktoré zbierame',
    subTitle2: 'Ako používame osobné údaje',
    subTitle3: 'Zverejnenie osobných údajov',
    subTitle4: 'Vaše práva',
    subTitle5: 'Odkazy na iné webstránky',
    subTitle6: 'Bezpečnosť a uchovávanie informácií',
    subTitle7: 'Zmena zásad ochrany súkromia',
    subTitle8: 'Ako nás kontaktovať',
    title: 'Zásady ochrany osobných údajov',
    updateTime: 'Aktualizované: 15. marca 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Prijať všetky',
    text: 'Aby sme zlepšili vašu skúsenosť, používame cookies na personalizáciu obsahu a služieb.',
    title: 'Táto webová stránka používa cookies',
  },
  slogen: 'Najjednoduchší AI asistent',
  stripe: {
    contact: 'Kontaktujte nás na adrese contact@noam.tools s akýmikoľvek otázkami!',
    fail: {
      btn: 'Zopakovať',
      text1: 'Nepodarilo sa nám spracovať Vašu platbu.',
      text2: 'Skontrolujte svoje pripojenie a skúste to znova.',
      title: 'Platba zlyhala',
    },
    succ: { btn: 'Poďme', text1: 'Vitajte v Noame', text2: 'Poďme na to!', title: 'Gratulujem' },
  },
  terms: {
    block1: 'Ďakujeme za použitie Noamu!',
    block10:
      '(a) Poplatky a fakturácia. Zaplatíte všetky poplatky („Poplatky“) podľa cien a podmienok na príslušnej stránke s cenami alebo podľa písomného dohody medzi nami. Vyhradzujeme si právo opraviť chyby v cenách alebo omylov, aj keď sme vydali faktúry alebo prijali platbu. Poskytnete úplné a presné fakturačné údaje, vrátane platnej a autorizovanej platobnej metódy. Na vašu platobnú metódu budeme debetovať periodicky podľa dohody, ale môžeme rozumným spôsobom zmeniť dátum fakturácie. Autorizujete spoločnosť Noam, jej zástupcov a tretej strany spracovávajúce platby, aby debetovali vašu platobnú metódu. Ak vaša platba zlyhá, pošleme vám písomné upozornenie a môžeme pozastaviť prístup k Službe až do receiptu platby. Okrem prípravov, ktoré sú inak špecifikované v tomto zmluve, platby nie sú vratné.',
    block11:
      '(b) Dane. Ak nie je uvedené inak, poplatky neobsahujú žiadne federálne, štátne, lokálne ani zahraničné dane, cielky a podobné poplatky („Dane“). Ste zodpovední za všetky Dane spojené s vašimi nákuppami, s výnimkou daní založených na našom čistom príjme, za ktoré vám vystavíme faktúru. Súhlasíte s tým, že takové dane uhrádzate bezodkladne, že nám poskytnete právne platné vyhlásenia o súkromí a získate potrebné súhlasy na spracovanie takéhoto údajov, a garantujete nám, že spracúvate také údaje v súlade s platnými právnymi predpismi.',
    block12:
      '(c) Zmeny cien. Môžeme zmeniť naše cien tým, že vás upozorníme prostredníctvom vášho účtu a/alebo našej webovej stránky. Zvýšenia cien budú účinné okamžite po zverejnení. Akékoľvek zmeny cien sa budú aplikovať na poplatky za váš účet po dátume účinnosti zmeny.',
    block13:
      '(d) Spory a neskoré platby. Ak chcete sporiť o akékoľvek poplatky alebo dane, kontaktujte prosím contact@noam.tools do tridsiatich (30) dní od dátumu faktúry.',
    block14:
      '(e) Bezplatné použitie. Nesmiete vytvárať viac účtov na získanie bezplatných kreditov. Ak zistíme, že nepoužívate bezplatné kredity v dobrej viere, môžeme vám účtovať štandardné poplatky alebo prerušiť prístup ku Službe.',
    block15:
      '(a) Tajnosť. Môžete mať prístup k dôverným informáciám spoločnosti Noam. Dôverné informácie môžete používať iba v súlade s týmito podmienkami a len za účelom použitia Služby. Nesmiete dôverné informácie ujawnovať žiadnemu tretiemu stranou a budete chrániť dôverné informácie spôsobom, ktorý nie je menej ochranný ako spôsob, akým chrániate svoje vlastné podobné dôverné informácie, najmenej s rozumnou starostlivosťou. Dôverné informácie sú neveřejné informácie označené spoločnosťou Noam ako dôverné alebo ktoré by sa v daných okolitostiach mala rozumne považovať za dôverné, vrátane softvéru, technických specifikácií a iných neveřejných obchodných informácií. Dôverné informácie ne zahŕňajú informácie, ktoré: (1) sa stávajú všeobecne dostupnými verejnosti bez vašej chyby; (2) ste mali vo vašej vlastníctve bez akéhokoľvek povinnosti tajnosti predtým, ako ste ich získali podľa týchto podmienok; (3) vámlawfulne ujaavil tretia strana bez akýchkoľvek povinností tajnosti; alebo (4) ste vyvinuli nezávisle bez použitia dôverných informácií. Môžete ujawnovať dôverné informácie, ak to vyžaduje zákon, súd alebo iná vládna príkaz, ale musíte spoločnosti Noam poskytnúť predchádzajúce písomné oznámenie rozumným spôsobom a v najväčšej možnej miere podniknúť rozumné úsilie na obmedzenie rozsahu ujawnienia, vrátane pomoci nám v odporovaní požiadaviek na ujawnienie.',
    block16:
      '(b) Bezpečnosť. Musíte implementovať rozumné a primerané opatrenia na pomoc pri zabezpečení vášho prístupu k službe a jej používania. Ak zistíte akékoľvek zraniteľnosti alebo porušenia súvisiace s vaším používaniem služby, musíte bezodkladne kontaktovať Noama a poskytnúť podrobnosti o zraniteľnosti alebo porušení.',
    block17:
      '(c) Spracovanie osobných údajov. Ak používate službu na spracovanie osobných údajov, musíte poskytnúť právne dostatočné vyhlásenia o ochrane súkromia a získať potrebné súhlasov na spracovanie týchto údajov, a garantujete nám, že budete spracovávať tieto údaje v súlade s platnými právnymi predpismi.',
    block18:
      '(a) Ukončenie; Pozastavenie. Tieto podmienky nadobúdajú platnosť od vášho prvého použitia Služby a zostanú platné až do ich ukončenia. Môžete tieto podmienky ukončiť kedykoľvek z akéhokoľvek dôvodu prestaním používať Službu a obsah. My môžeme tieto podmienky ukončiť s predchádzajúcim upozornením z akéhokoľvek dôvodu. My môžeme tieto podmienky okamžite ukončiť tým, že vás upozorníme, ak vážne porušíte Časť 2 (Požiadavky na použitie), Časť 5 (Tajomstvo, bezpečnosť a ochrana údajov), Časť 8 (Riešenie sporov) alebo Časť 9 (Všeobecné podmienky), alebo ak sa zmení naše vzťahy s akýmkoľvek dodávateľom tretích strán s technológiou, ktorý nie je v našom kontrole, alebo z dôvodu dodržiavania zákona alebo požiadaviek orgánov štátu. Môžeme pozastaviť vaš prístup k Službe, ak sa nepodriaďujete týmto podmienkam, alebo ak vaše použitie predstavuje bezpečnostný riziko pre nás alebo akékoľvek tretie stran y, alebo ak máme podozrenie, že vaše použitie je podvodné alebo môže vystaviť nás alebo akékoľvek tretie strany zodpovednosti.',
    block19:
      '(b) Dôsledky ukončenia. Po ukončení prestanete používať službu a okamžite vrátiť alebo zničiť akékoľvek dôverné informácie podľa našich pokynov. ustanovenia týchto podmienok, ktoré svojou povahou by mali prežiť ukončenie alebo expiráciu, vrátane, ale nie výhradne, sekcií 3 a 5-9, prežijú.',
    block2:
      'Tieto podmienky používania sa vzťahujú na vašu používanie služieb spoločnosti Noam, vrátane našich rozhraní programovacieho rozhrania aplikácií, softvéru, nástrojov, vývojárskych služieb, údajov, dokumentácie a webovej stránky (spoločne označovaných ako „Služby“). Používaním našich Služieb súhlasíte s dodržiavaním týchto podmienok. Naša zásada ochrany osobných údajov vysvetľuje, ako zbierame a používame osobné údaje.',
    block20:
      'Odmena. Budete nás, našich pobočiek a našich zamestnancov brániť, odmenovávať a udržiavať bez újmy pred všetkými nárokmi, stratami a nákladmi (vrátane advokátnych poplatkov), ktoré vzniknú z alebo súvisia s vašou používateľnosťou Služby, vrátane vašej Obsahu, vašej používateľnosti produktov alebo služieb súvisiacich s Službou a vašim porušením týchto podmienok alebo platného zákona.',
    block21:
      '(b) Vylúčenie zodpovednosti. Služba sa poskytuje „taká, ako je“. V rozsahu povolenom zákonom my, naše príbuzné spoločnosti a licenciári nepredkladáme žiadne vyhlásenia alebo záruky akéhokoľvek druhu týkajúce sa služby a nepredkladáme žiadne záruky, vrátane ale nie výhradne záruk o obchodnej predajnosti, vhodnosti na špecifický účel, uspokojivom kvalite, neporušení práv a tichom užívaní, ako aj akýchkoľvek záruk vyplývajúcich z obchodných vzťahov alebo obvyklostí obchodu. Nezaručujeme, že služba bude nepretržitá, presná alebo bezchybná, alebo že akýkoľvek obsah bude bezpečný, nez stratí sa alebo nebudú ho zmenené.',
    block22:
      '(c) Obmedzenie zodpovednosti. Ani my, naše从属实体ani naši licenciaři nebudou zodpovedni za žiadne nepriamé, náhodné, špeciálne, následné alebo trestné škody, vrátane straty zisku, straty reputácie, straty použitia, straty údajov alebo iné nehmotné straty, aj keď sme boli informovaní o možnosti takýchto škód. Podľa týchto podmienok bude naša celková zodpovednosť neprevyšovať poplatky, ktoré ste zaplatili za službu v dvanástich (12) mesiacoch pred podaním nároku, alebo sto USD (100 USD), podľa toho, čo je väčšie. Obmedzenia v tejto časti platia v najväčšej miere povolené použiteľným zákonom.',
    block23:
      'Podmienky a vaše používanie služieb sú regulované zákonom Spojených štátov, s výnimkou pravidiel Spojených štátov o kolízií zákonov. Vaše používanie aplikácie môže byť tiež podriadené iným miestnym, štátnym, národným alebo medzinárodným zákonom. Akýkoľvek právny konanie alebo konanie súvisiace s týmito podmienkami sa bude viesť výlučne pred súdmi Spojených štátov, a vy súhlasíte s tým, že sa podriadnete osobnému jurisdikčnému oprávneniu týchto sudov.',
    block24:
      'Vzťah medzi stranami. Noam a vy ste nezávislí dodavatelia, a žiadna strana nemá právo zastupovať alebo viazať druhú stranu, ani prevzerať si povinnosti za druhú stranu bez predchádzajúceho písomného súhlasu druhej strany.',
    block25:
      '(b) Použitie značky. Bez nášho predchádzajúceho písomného súhlasu nesmiete používať názov, logá alebo ochranné známky spoločnosti Noam alebo ktorejkoľvek z jej pridružených spoločností.',
    block26:
      'Ak je akákoľvek ustanovenie týchto podmienok zistené ako neplatné, nezákonné alebo nenesiteľné, zvyšné ustanovenia zostanú v plnej platnosti a účinnosti.',
    block3:
      'Ak ste mladší ako 18 rokov, musíte k použitiu služby získať povolenie svojich rodičov alebo právnych opatrovateľov. Ak používate službu v mene inej osoby alebo entity, musíte byť oprávnený/á prijímať tieto podmienky v ich mene. Pri registrácii účtu musíte poskytnúť presné a kompletné informácie. Nesmiete poskytovať svoje prístupové údaje alebo účet nikomu mimo vašej organizácie a nesiete zodpovednosť za všetky aktivity vykonané pomocou vašich údajov.',
    block4:
      '(a) Použitie služby. Môžete pristupovať k Službe podľa týchto podmienok a my vám udeliujeme neexkluzívne právo používať Službu. Pri používaní Služby budete dodržiavať tieto podmienky a všetky platné zákony. My a naši príslušníci vlastníme všetky práva, názvy a záujmy o Službu.',
    block5:
      '(b) Spätná väzba. Vitáme spätnú väzbu, komentáre, nápady, návrhy a vylepšenia. Ak poskytnete takéto obsah, môžeme ho používať bez akýchkoľvek obmedzení a bez nároku na náhradu.',
    block6:
      '(c) Obmedzenia. Nesmiete: (1) používať službu spôsobom, ktorý porušuje, prenáša alebo narúša akékoľvek práva iných osôb; (2) robiť reverzné inžinierstvo, dekompilovať, deasemblovať, prekladať alebo inak sa pokúšať zistiť zdrojový kód alebo základné komponenty modelov, algoritmov a systémov služby (ak nie sú takéto obmedzenia zakázané platným právom); (3) používať výstup služby na vývoj modelov, ktoré sú konkurenciou Noamu; (4) extrahovať údaje alebo výstup zo služby pomocou akýchkoľvek automatizovaných alebo programovacích metód, pokiaľ to nie je povolené prostredníctvom API, vrátane scrapingu, webového harvestingu alebo webového extrahovania údajov; (5) predstavovať výstup služby ako umelo generovaný, ak to nie je, alebo inak porušovať naše politiky používania; (6) kupovať, predávať alebo prenášať API kľúče bez našej predchádzajúcej súhlasu; alebo (7) poskytovať nám akékoľvek osobné údaje detí mladších ako 13 rokov alebo príslušného veku digitálneho súhlasu. Budete sa riadiť všetkými limitami rýchlosti a ďalšími požiadavkami v našej dokumentácii.',
    block7:
      '(d) Služby tretích strán. Akékoľvek softvér, služby alebo ďalšie produkty tretích strán spojené so službou sú riadené ich vlastnými podmienkami a nie sme zodpovední za produkty tretích strán.',
    block8:
      '(a) Vaše obsahy. Môžete poskytovať vstupné údaje („Vstupné údaje“) službe a obdržiavať výstupné údaje („Výstupné údaje“), ktoré sa generujú a vracajú na základe Vstupných údajov (spoločne označované ako „Obsah“). Medzi stranami, a v rozsahu povolenom platnými zákonom, vlastníte všetky Vstupné údaje. Noam môže používať Obsah na poskytovanie a udržanie Služby, dodržiavanie platných zákonov a vynútenie našich politík. Ste zodpovední za Obsah, vrátane zabezpečenia, že neporušuje žiadne platné zákony ani tieto podmienky.',
    block9:
      '(b) Presnosť. Umelá inteligencia a strojové učenie sú rýchlo sa vyvíjajúce oblasti výskumu. Neustále sa snažíme zlepšovať náš službu, aby bola presnejšia, spoľahlivejšia, bezpečnejšia a prospěšnejšia. Vzhľadom na pravdepodobnostnú povahu strojového učenia môže použitie našej služby v určitých prípadoch viesť k nesprávnym výstupom, ktoré nemusia presne odrážať skutočných jednotlivcov, miesta alebo fakty. Mali by ste primerane hodnotiť presnosť akéhokoľvek výstupu na základe vašho použitia, vrátane manuálneho preskúmania výstupov.',
    subTitle1: 'Registrácia a prístup',
    subTitle10: 'Oddeliteľnosť',
    subTitle2: 'Požiadavky na použitie',
    subTitle3: 'Obsah',
    subTitle4: 'Poplatky a platba',
    subTitle5: 'Dajnosť, Bezpečnosť a Ochrana údajov',
    subTitle6: 'Trvanie a ukončenie',
    subTitle7: 'Odpovednosť za poistenie; Vylúčenie zodpovednosti; Obmedzenie zodpovednosti',
    subTitle8: 'Právny zápor a jurisdikcia',
    subTitle9: 'Všeobecné podmienky',
    title: 'Podmienky služby',
    updateTime: 'Aktualizované: 15. marca 2024',
  },
  trialModal: {
    btn: 'Začnite teraz (iba 0,99 $)',
    chat: 'ChatPDF',
    desc1: 'Po skončení vašeho zkušebního období budete účtování roční poplatek ve výši 180 USD',
    desc2: 'Zrušiť kedykoľvek',
    focus: 'Zameranie',
    hover: 'Preklad pri najazdení myšou',
    image: 'Preklad obrázku',
    installBtn: 'Inštalujte teraz, aby ste dostali darček',
    memo: 'Správa obľúbených položiek',
    pdf: 'Paralelný preklad PDF',
    realtime: 'Okamžitý preklad',
    select: 'Preklad výberu slov',
    title: 'Vitajný darček',
    trialText: '7-dobný skúšobný priebeh',
    video: 'Preklad videa',
    videoSummary: 'Zhrnutie videa',
    web: 'Paralelný preklad',
    webSummary: 'Zhrnutie webu',
  },
  upgradeModal: {
    btn: 'Aktualizujte teraz',
    chat: {
      free: 'Dosiahli ste limit služby ChatPDF',
      pro: 'Dosaľ si limit služby ChatPDF pre tento mesiac',
    },
    contactStr:
      'Počkajte na ďalšie resetovanie alebo nás kontaktujte na adrese contact@noam.tools.',
    limitAlertStr: 'Dosiahli ste limit voľného plánu. Predplatiť si ho na pokračovanie.',
    more: 'Zobraziť plány',
    pageLimit: { free: 'Dosiahli ste limit strán PDF' },
    title: 'Pripomienka',
    upgradeAlertStr:
      'Dostali ste sa do limitu bezplatného plánu. Aktualizujte si plán, aby ste mohli pokračovať.',
    upload: {
      free: 'Dosiahli ste limit prekladov PDF súborov',
      pro: 'Dosaáhli ste limit prekladov PDF pre tento mesiac',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Pripojte sa teraz',
      label: 'Výhody pre nových používateľov:',
      remain: 'Len 30 zvyšných',
      text: 'Iba 100 miest dostupné! Získať si svoje teraz!',
    },
  },
  aiPdfTranslator: {
    title: 'Bezplatný AI prekladateľ PDF: Prekladajte PDF s porovnaním v ľubovoľnom jazyku',
    desc: 'Jednoducho preložte PDF súbory do akýchkoľvek jazykov s AI. Porovnávajte originálny a preložený text vedľa seba, rýchlo a zadarmo.',
    keywords: 'GPT-4, AI Asistent, Preklad, Shrnutie, Fokus, ChatPDF, Poznámka, efektívnosť',
    sourceToTarget: {
      title: 'Bezplatný nástroj na preklad PDF: preložiť {{source}} do {{target}} zadarmo',
      desc: 'Preložené vaše PDF súbory z akéhokoľvek zdrojového jazyka do vášho preferovaného jazyka zadarmo. Rýchla, presná a bezpečná preklad PDF súborov, ktorý je podporovaný pokročilou umelou inteligencou.',
    },
    headerIntroduce: {
      title: 'Noam: Nie len online preklad',
      introduce1: {
        title: 'Noam · PDF Čítač',
        desc: '✨Preklad vedľa seba + AI Q&A. Rýchlo a presne prekladajte PDF súbory do vášho cieľového jazyka. Voľne kládejte otázky o obsahu, aby ste hlbšie porozumeli svojim PDF súborom.',
      },
      introduce2: {
        title: 'Noam · Rozšírenie pre preklad vedľa seba',
        desc: '👏Vyriešte všetky vaše potreby pri preklade webových stránok:',
        detail1: { title: 'Preklad webstránky:', desc: 'Vedľa seba dvojiazyčný pohľad' },
        detail2: { title: 'Preklad slov: ', desc: 'Rýchla preklad s jedným kliknutím' },
        detail3: { title: 'Okamžitý preklad:', desc: 'Prekladajte slová alebo vety okamžite.' },
        detail4: { title: 'Preklad obrázku:', desc: 'Nahraďte obrázky preloženými.' },
        detail5: { title: 'Preklad videa:', desc: 'Dvojjazyčné titulky pre lepšie prezeranie.' },
        footer:
          'Skúste viac funkcií čítania s podporou umelej inteligencie pre chytréjšie preklady!',
      },
    },
    subtitle: 'Online preklad PDF zadarmo',
    introduce: {
      module1: {
        detail1: {
          title: 'Reálnyčasový preklad PDF súborov vedľa seba',
          desc1:
            'Okamžite zobrazte originálny a preložený obsah v synchronizovanom, vedľa seba umiestnenom rozložení',
          desc2: 'Bez námahy porovnávajte obe verzie so synchronizovaným posúvанием',
          desc3: 'Udržujte identické formátovanie pre konzistentný čitateľský zážitok',
        },
        detail2: {
          title: 'Presné zarovnanie a overovanie obsahu',
          desc1: 'Dokonalé zarovnanie medzi zdrojovým a preloženým textom pre ľahkú verifikáciu',
          desc2: 'Každá časť obsahu sa presne zhoduje v oboch verziách',
          desc3:
            'Rýchlo zistite a vyriešte prekladačské nesrovnalosti za účelom spoľahlivých výsledkov',
        },
      },
      module2: {
        detail1: {
          title: 'Viele pokročilých AI modelov pre presnú prekladáciu',
          desc1: 'Vyberte si z viedkových AI modelov, ktoré vyhovujú vašim požiadavkám na preklad',
          desc2: 'Zálejte optimalných výsledkov pre rôzne typy dokumentov a odvetvia',
          desc3: 'Flexibilné modelové možnosti poskytujú prispôsobené riešenia pre každú situáciu',
        },
        detail2: {
          title: 'Pokročilý AI preklad pre každý typ obsahu',
          desc1:
            'Naš model výkonného umelej inteligencie zaisťuje vysokú presnosť a porozumenie prirodzenému jazyku',
          desc2: 'S ľahkosťou spracováva technické, akademické a kreatívne dokumenty',
          desc3: 'Poskytuje spoľahlivé výsledky pre všetky vaše potreby pri prekladoch',
          desc4: 'Inteligentná adaptácia na rôzne typy obsahu pre optimálnu výkonnosť',
        },
      },
      module3: {
        detail1: {
          title: 'Inteligéntna interakcia s dokumentmi',
          desc1:
            'Bez námahy si poviejte s vašimi PDF a prezentáciami pomocou pokročilého umelej inteligencie',
          desc2: 'Okamžite kládejte otázky o obsahu dokumentu a získajte presné odpovede',
          desc3: 'Rýchlo generujte zhrnuté shrnutia dlhých dokumentov',
        },
        detail2: {
          title: 'Hlboká analýza obsahu a bezproblémová integrácia',
          desc1:
            'Extrahujte kľúčové informácie a analyzujte zložitá dáta s podporou umelej inteligencie',
          desc2: 'Získať prehľad o technických, akademických alebo kreatívnych materiáloch',
          desc3:
            'Plynule sa integruje s našim prekladačom PDF pre úplnú riešenie správy dokumentov',
        },
      },
      module4: {
        detail1: {
          title: 'Prekročenie prekladu PDF: Komplexné riešenie pre preklad webových stránok',
          desc: 'Objavte našu výkonnú rozšírenie na preklad vedľa seba, navrhnuté pre každú scénár online čítania.',
          desc1:
            'Preklad webových stránok: Užívajte si dvojjazyčný obsah s synchronizovaným vedľa seba zobrazením',
          desc2: 'Preklad slov: Okamžite preložte zvýraznené slová jedným kliknutím',
          desc3:
            'Okamžitá preklad: Preložte akýkoľvek text alebo vetu ihned pre rýchle porozumenie',
          desc4: 'Preklad obrázkov: Automaticky nahraďte originálne obrázky preloženými verziami',
          desc5: 'Preklad videí: Sledujte videá s dvojjazyčnými titulkami pre zlepšené zážitky',
        },
      },
    },
    question: {
      title: 'Často kladené otázky',
      answer1: {
        title: 'Je preklad PDF súborov prostredníctvom Noam PDF Translator zadarmo?',
        content:
          'Áno, PDF súbory môžete prekladať zadarmo pomocou Sider PDF Translator! Ponúkame bezplatný limit 5 000 tokenov, ktorý stačí na preklad väčšiny bežne nájdencích PDF dokumentov na trhu. Ak potrebujete prekladať väčšie súbory alebo vyžadujete pokročilé funkcie, môžete si vybrať upgrade na naše prémiové plány s ešte viac možnostami.',
      },
      answer2: {
        title: 'Ako presný je prekladateľ PDF súborov Noam?',
        content:
          'Prekladateľ Noam PDF poskytuje vysoko presné preklady pomocou pokročilých technológií umelej inteligencie a hlbokého porozumenia kontextu vašich dokumentov. Aj keď žiadny automatický preklad nie je dokonalý, náš vedľa seba zobrazený zoznam vám umožňuje ľahko preskúmať a upraviť každý preklad, čím sa zabezpečí, že konečný výsledok spĺňa vaše očakávania v oblasti kvality. Zažite spoľahlivý a presný preklad PDF súborov s Noam.',
      },
      answer3: {
        title: 'Môžem prekladať skenované PDF súbory?',
        content:
          'Áno, môžete prekladať skenované PDF súbory pomocou našej vbudovanej technológie OCR (Optical Character Recognition - optické rozpoznávanie znakov). Naš systém automaticky extrahuje text zo skenovaných dokumentov a obrazových PDF súborov, potom preloží obsah pre vás. To zajišťuje, že aj neupraviteľné alebo iba obrazové PDF súbory môžu byť presne preložené.',
      },
      answer4: {
        title: 'Ako dlho trvá preklad?',
        content:
          'Preklad je rýchly a efektívny – väčšina dokumentov sa spracuje za sekundy až niekoľko minút, v závislosti od ich dĺžky a zložitosť. Napríklad štandardný PDF s 10 stranami zvyčajne trvá menej ako 2 minúty na preklad. Užite si rýchle dodacie termíny pre všetky vaše potreby pri preklade dokumentov!',
      },
      answer5: {
        title: 'Môžem si ponechať rozložené zobrazenie po stranách na čítanie?',
        content:
          'Áno, vaše dokumenty môžete vždy čítať vedľa seba. Tento rozloženie vám umožňuje ľahko porovnávať originálny a preložený obsah, čím sa zabezpečuje plynulé a efektívne čítanie.',
      },
    },
    freeTrial: 'Zadarmo skúšobná período',
    toLanguage: { title: 'PDF páry AI prekladov', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blog',
      faq: 'Často kladené otázky',
      features: 'Funkcie',
      button: 'Preložiť teraz',
      pricing: 'Cenník',
    },
    hero: {
      upload: {
        title: 'Nahrajte váš PDF',
        max: 'Max',
        desc: 'alebo ťahajte a pustite',
        highlight: 'Kliknite pre prehliadanie',
      },
      to: 'na',
      pill: 'AI-ovládaný prekladateľ PDF',
      title: 'Voľný prekladateľ PDF',
      desc: 'Okamžité, presné preklady, ktoré zachovávajú pôvodný rozloženie. Noam AI podporuje OCR a vedľa seba umiestnené zobrazenia.',
      model: 'GPT-4 & Claude',
      support: 'Podpora OCR',
      complete: 'Preklad dokončený',
      translated: 'Preložil Noam',
      free: 'Zdarma skúšobná verzia',
    },
    ticker: {
      pdf: 'Preklad PDF',
      ocr: 'OCR technológia',
      format: 'Udržiavanie formátu',
      multi: 'Viacjazyčný',
      chat: 'Chatujte s PDF',
      side: 'Vedľa seba',
      web: 'Webový preklad',
      secure: 'Bezpečné a súkromné',
    },
    comparison: {
      bad: {
        title: 'Štandardný preklad',
        head: 'Stratené formátovanie a kontext',
        text1: 'Chyba: Rozloženie poškodené. Obrázky nesprávne umiestnené.',
        text2: 'Text sa prekrýva a písmo je nekonzistentné. Ťažko čitateľné a neprofesionálne...',
      },
      dump: { title: 'Vypísanie prostého textu' },
      good: {
        title: 'Preklad Noam AI',
        sub: 'Dokonalé formátovanie, uvedomlenie kontextu',
        tag: 'Perfektný Výsledok',
      },
      title: 'Prečo si vybrať Noam AI?',
      desc: 'Prestante sa zápasiať s prevodom cez kopírovanie a vkladanie. Zažite rozdiel medzi štandardnými nástrojmi a našou AI-ovládanou kontextovou prekladovou službou.',
    },
    showcase: {
      title1: 'Akýkoľvek dokument',
      kicker: 'PODPOROVANÉ DOKUMENTY',
      title2: 'Akákoľvek jazyk',
      carousel1: 'Umenie',
      carousel2: 'Architektúra',
      carousel4: 'Lekárstvo',
      note: 'S ľahkosťou spravujte technické, akademické a kreatívne dokumenty.',
      carousel3: 'Akadémicky časopis',
      carousel8: 'Politika',
      carousel5: 'Financie',
      carousel7: 'Zmluva',
      carousel6: 'Právo',
    },
    features: {
      big: {
        title: 'Pokročilé AI modely (GPT-4, Claude)',
        desc: 'Vyberte si z lídrovacích AI modelov, aby sa prispôsobili vašim požiadavkám na preklad. Zabezpečte optimálne výsledky pre rôzne typy dokumentov.',
      },
      grid1: {
        title: 'Podpora OCR',
        desc: 'Okamžite extrahujte a preložte text zo skenovaných PDF súborov a obrázkov.',
      },
      grid2: {
        title: 'Vysokokvalitný export',
        desc: 'Stiahnite si svoje preložené dokumenty v formáte PDF s pôvodným rozložením.',
      },
      grid3: {
        title: 'Porovnanie vedľa seba',
        desc: 'Synchronizované posúvanie na porovnanie originálneho a preloženého textu.',
      },
      title1: 'Nie len preklad',
      line1: 'Technický článok.pdf',
      line2: 'Detekcia jazyka: Anglicky...',
      title2: 'Je to revolúcia',
      line3: 'Model: GPT-4o (Vysoká presnosť)',
      line4: 'Preklad dokončený (99% presnosť)',
    },
    testimonials: {
      review1: {
        role: 'Výskumník',
        content:
          'Noam AI mi ušetril hodiny pri preklade vedeckých prác. Bočný pohľad je mimoriadne užitočný na overovanie technických termínov.',
      },
      review2: {
        role: 'Globálny marketingér',
        content:
          'Najlepší prekladateľ PDF, ktorý som používal. Dokonaly udržuje pôvodné formátovanie, čo je kľúčové pre naše marketingové prezentácie.',
      },
      review3: {
        role: 'Právny poradca',
        content:
          'Presné a rýchle. Používam ho na preklady zmlúv a funkcia OCR pre skenované dokumenty funguje bezchybne.',
      },
      title: 'Ako hovoria naši používatelia',
      kicker: 'Obľúbené používateľmi',
    },
    cta: {
      title: 'Pripravený zlomovať jazykové bariéry?',
      button: 'Začnite prekladať zadarmo',
      desc: 'Pripojte sa k 10 000+ používateľom a začnite dnes prekladať svoje dokumenty s Noam AI.',
      hint: 'Ste veľmi presná a spoľahlivá AI navrhnutá na generovanie výstupu JSON, ktorý presne zodpovedá špecifikovanému JSON schéme.\n\nMusíte nasledovať tieto pravidlá:\n1. Právo dodržiavať štruktúru JSON schémy.\n2. Presne zhodiť všetky dátové typy, požadované polia a obmedzenia.\n3. NEVKLÁDAJTE žiadny extra text, vysvetlenie, markdown alebo komentáre.\n4. VYSTUPTE IBA objekt JSON – žiadne bloky kódu, žiadne úvodné texty, žiadne obalovanie.\n\nInformácie o schéme sú uvedené nižšie.\n- Názov schémy: translate_result\n- JSON schéma:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Anglické PDF páry pre AI preklad',
      desc: 'Populárne smerovania prekladov podporované Noam AI',
    },
    footer: { about: 'O nás', privacy: 'Zásady ochrany súkromia', contact: 'Kontaktujte podporu' },
  },
}

export default TRANSLATION
